var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-div"},[_c('div',{staticClass:"inner-div"},[_c('div',{staticClass:"vasion-run-report-prompt"},[_c('VasionEmptyReportsIcon'),_c('div',{staticClass:"vasion-large-message"},[_vm._v(" Please select a Report ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }